import React from "react";

const About = () => {
  return (
    <div
      id="about"
      className="relative w-full h-min flex flex-col justify-center max-w-screen-2xl py-8 overflow-hidden cursor-pointer"
    >
      <h1 className="w-full my-2 text-sectionTitle2 md:text-sectionTitle1 text-center pr-8">
        About Us
      </h1>
      <div className="w-full flex flex-col lg:flex-row justify-center items-center py-4">
        <div className="w-full lg:w-3/5 p-8 lg:p-16">
          <p className="text-sectionTitle6 md:text-sectionTitle5 leading-7 lg:leading-10">
            At K.S Team Plus, we bring over 30 years of expertise in the steel
            wire industry. Headquartered in Tokyo and Shanghai, our wire and
            speaker manufacturing facilities supply not only Japan and China,
            but also extend to markets in South Korea, the United States, and
            beyond. <br /> <br />
            Our product portfolio covers a wide range of premium solutions,
            including carbon spring steel wire, phosphated steel wire,
            galvanized steel wire, smooth steel wire rope, galvanized steel wire
            rope, and stainless steel wire. With a strong commitment to quality,
            innovation, and global partnerships, we continue to deliver reliable
            products that meet the diverse needs of our international clients.
          </p>
        </div>
        <div className="w-full lg:w-2/5 max-h-[768px] p-8">
          <img
            src="./images/covers/speaker/landing9.jpg"
            className="w-full h-full object-contain"
            alt="about us"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
